import { collectionPoints } from "../../../data/collectionPoints";

export default function FulfilmentStep({
  country,
  fulfilment,
  setFulfilment
}) {
  const countryData = collectionPoints[country];

  const collectionPoint = countryData?.points?.[0];

  const collectionFee = countryData?.collectionFee ?? 0;

  return (
    <div style={{ marginBottom: 40 }}>
      <h3
        style={{
          fontSize: "14px",
          textTransform: "uppercase",
          color: "#C4773B",
          marginBottom: 20
        }}
      >
        Step 3 — How would you like to receive it?
      </h3>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 12
        }}
      >
        {/* COLLECTION */}

        <button
          type="button"
          onClick={() => setFulfilment("collection")}
          style={{
            padding: 20,
            textAlign: "left",
            background:
              fulfilment === "collection"
                ? "rgba(196,119,59,0.12)"
                : "transparent",
            border:
              fulfilment === "collection"
                ? "1px solid #C4773B"
                : "1px solid rgba(26,22,17,0.12)",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              fontSize: 22,
              marginBottom: 12
            }}
          >
            🏪
          </div>

          <div
            style={{
              fontWeight: 500,
              marginBottom: 6
            }}
          >
            Collect in person
          </div>

          {collectionPoint ? (
            <>
              

              <div
                style={{
                  marginTop: 12,
                  color: "#C4773B",
                  fontSize: 13
                }}
              >
                {collectionFee === 0
                  ? "Free collection"
                  : `Collection fee: Ksh. ${collectionFee}`}
              </div>
            </>
          ) : (
            <div
              style={{
                fontSize: 12,
                color: "#000"
              }}
            >
              No collection point is currently available for this country.
            </div>
          )}
        </button>

        {/* DELIVERY */}

        <button
          type="button"
          onClick={() => setFulfilment("delivery")}
          style={{
            padding: 20,
            textAlign: "left",
            background:
              fulfilment === "delivery"
                ? "rgba(196,119,59,0.12)"
                : "transparent",
            border:
              fulfilment === "delivery"
                ? "1px solid #C4773B"
                : "1px solid rgba(26,22,17,0.12)",
            cursor: "pointer"
          }}
        >
          <div
            style={{
              fontSize: 22,
              marginBottom: 12
            }}
          >
            📦
          </div>

          <div
            style={{
              fontWeight: 500,
              marginBottom: 6
            }}
          >
            Deliver to me
          </div>

          <div
            style={{
              fontSize: 12,
              color: "#C4773B",
              lineHeight: 1.5
            }}
          >
            Delivery fee is not included.
            <br />
            Once your order is confirmed, we will contact you to arrange
            delivery and share the delivery cost.
          </div>
        </button>
      </div>
    </div>
  );
}